"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scrollbars = void 0;
var Scrollbars_1 = require("./Scrollbars");
Object.defineProperty(exports, "Scrollbars", { enumerable: true, get: function () { return Scrollbars_1.Scrollbars; } });
exports.default = Scrollbars_1.Scrollbars;
